import { FC } from 'react'

import s from './s.module.scss'

const CustomLoading: FC = () => {
  return (
    <div className={s.wrapLoading}>
      <div className={s.ring} />
    </div>
  )
}

export default CustomLoading
